import React from "react";
import styled, {ThemeProvider} from "styled-components";
import {
  CtaWireframeButton,
  FullWidthContainer, Heading1,
  Heading3,
  Highlight,
  MaxWidthContainer, Paragraph
} from "../style/itf-styled-components";
import {ExternalLink} from "../components/external-link";
import {
  useLogisticPartners,
  useMediaPartners,
} from "../data/hooks/partners";
import PartnerBox from "../components/partner-box";
import {useThemes} from "../style/themes.hook";
import SEO from "../components/seo";
import Header from "../components/header/header";
import Footer from "../components/footer";
import CookiesConsent from "../components/cookies-consent";
import {CookiesProvider} from "react-cookie";

export const PartnersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const Partner = styled(ExternalLink)`
  padding: 10px;
`;

const PartnersPage = () => {
  const themes = useThemes();

  const mediaPartners = useMediaPartners();
  const logisticPartners = useLogisticPartners();

  return (
    <>
      <SEO
        title={`Parteneri`}
        description={`Vă prezentăm brandurile care au avut încredere în noi și susțin existența Imagine Timisoara Festival.`}
      />
      <ThemeProvider theme={themes.light}>
        <Header page="parteneri"/>
        <FullWidthContainer>
          <MaxWidthContainer css={`padding: 50px 25px;`}>
            <Heading1>Parteneri</Heading1>
            {!!mediaPartners.length && (
              <>
                <Heading3 as="h3">Parteneri Media</Heading3>
                <PartnersList>
                  {mediaPartners.map((partner, index) => (
                    <Partner to={partner.website} key={index}>
                      <PartnerBox partner={partner} size="small" />
                    </Partner>
                  ))}
                </PartnersList>
              </>
            )}

            {!!logisticPartners.length && (
              <>
                <Heading3 as="h3">Parteneri Logistici</Heading3>
                <PartnersList>
                  {logisticPartners.map((partner, index) => (
                    <Partner to={partner.website} key={index}>
                      <PartnerBox partner={partner} size="small" />
                    </Partner>
                  ))}
                </PartnersList>
              </>
            )}
            <br/>
            <Heading3 as="h3">Dorești să devii susținător al Imagine Timisoara Festival?</Heading3>
            <Heading3 as="h3">Scrie-ne la <Highlight as={ExternalLink} to="mailto:office@imaginetimisoara.ro"><strong>office@imaginetimisoara.ro</strong></Highlight></Heading3>
            <Paragraph>
                <CtaWireframeButton
                  as={ExternalLink} to="/downloads/itf-2021-mapa-de-prezentare.pdf"
                >Mapa de prezentare</CtaWireframeButton>
              </Paragraph>

              <Paragraph>
                <CtaWireframeButton
                  as={ExternalLink} to="/downloads/itf-2021-presentation-brochure.pdf"
                >Presentation Brochure</CtaWireframeButton>
              </Paragraph>
          </MaxWidthContainer>
        </FullWidthContainer>
        <Footer/>

        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      </ThemeProvider>
    </>
  );
};

export default PartnersPage;